import React, { Component } from "react";
import {
  Statistic,
  Card,
  Row,
  Col,
  Icon,
  Avatar,
  Divider,
  Spin,
  Alert,
  Skeleton,
  Table,
} from "antd";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";
import moment from "moment";
import TodayTime from "../../components/dashboard/today_time";
import BasicCard, {
  BasicCardCenter,
  EngineStatus,
} from "../../components/basic_card";
import { main_menu_list } from "../index";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { RESTExecutor, withDomains } from "../../lib/domain";
import { formatMoney, showErrorInNotification } from "../../lib/util";
import ErrorWrapper from "../../lib/error_wrapper";
import { COLORS } from "../theme";
import { IconCard } from "../../components/basic_items";
import EngineStatusCard from "../../components/engine_status_card";
import {
  ReorderOutlined,
  StorageOutlined,
  FlipOutlined,
  AssessmentOutlined,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import { BasicHeader } from "../../components/basic_header";
import { dashboard_quick_menu } from "../../util/ui_util";
import KeyboardShortcutWrapper from "../../util/keyshortcuts";

const CountAndAmount = ({ count = "N/A", amount = 0 }) => {
  return (
    <Statistic
      className="center-statistic"
      title={`${count} Transactions`}
      value={`Rs. ${formatMoney(amount, 2, ".", ",")}`}
    />
  );
};

const reconciled_this_week = [
  { day: "SUN", count: 0 },
  { day: "MON", count: 4000 },
  { day: "TUE", count: 1000 },
  { day: "WED", count: 120 },
  { day: "THU" },
  { day: "FRI", count: 320 },
  { day: "SAT", count: 0 },
];

const list_pending = [
  {
    date: "2019-11-02",
    id: 3,
    remark: "lkjn",
    row_id: 115153,
    status: "done",
  },
  {
    date: "2019-11-02",
    id: 3,
    remark: "lkjn",
    row_id: 115153,
    status: "done",
  },
  {
    date: "2019-11-02",
    id: 3,
    remark: "lkjn",
    row_id: 115153,
    status: "done",
  },
  {
    date: "2019-11-02",
    id: 3,
    remark: "lkjn",
    row_id: 115153,
    status: "done",
  },
];

class TodayPage extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.today_stat = RESTExecutor.detail()
      .config({
        label: "today",
      })
      .connect(props.domains.dashboard);

    this.list_favourite_datatype = RESTExecutor.list()
      .config({
        url: "/my-data-types?favourite=true&per_page=5",
      })
      .callbacks(
        () => {},
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.dashboard);

    this.list_favourite_groups = RESTExecutor.list()
      .config({
        url: "/my-groups?favourite=true&per_page=5",
      })
      .callbacks(
        () => {},
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.dashboard);

    this.list_pending_tasks = RESTExecutor.list()
      .config({
        url: "/my-tasks/follow-ups?view=dashboard&per_page=5",
      })
      .callbacks(
        () => {},
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.dashboard);
  }

  render() {
    // console.log("props", this.props.authenticator.getTokens().meta)
    const { authenticator } = this.props;
    let tok_data = authenticator.getTokens() || {};
    let meta = tok_data.meta || {};

    let user = meta.user_data || {};

    let responsive_card_grid = {
      xs: 24,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 8,
      xxl: 8,
    };
    let responsive_card_engine = {
      xs: 24,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 6,
      xxl: 6,
    };
    let responsive_card_favourite = {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12,
    };

    let today_stat_resp = this.today_stat.response();
    let list_favourite_groups_resp = this.list_favourite_groups.response();
    let list_favourite_datatype_resp = this.list_favourite_datatype.response();
    let list_pending_tasks_resp = this.list_pending_tasks.response();

    let favourite_datatypes =
      (list_favourite_datatype_resp.result &&
        list_favourite_datatype_resp.result.rows) ||
      [];
    let favourite_reconcilers =
      (list_favourite_groups_resp.result &&
        list_favourite_groups_resp.result.rows) ||
      [];

    let pending_tasks =
      (list_pending_tasks_resp.result && list_pending_tasks_resp.result.rows) ||
      [];

    let today_detail = today_stat_resp.result || {};
    let engine_status = today_detail.engine_status || {};
    let reconciled_today = today_detail.reconciled_today || {};

    let now = moment().hour();

    return (
      // <Spin spinning={today_stat_resp.fetching}>
      <div>
        <BasicHeader
          title="Today"
          no_back
          right={[
            <div
              style={{
                color: COLORS.secondary,
              }}
            >
              Last Login : {tok_data.last_login || "N/A"}
            </div>,
            tok_data.invalid_login_attempts > 0 ? (
              <>
                |
                <div
                  style={{
                    color: COLORS.danger_primary,
                  }}
                >
                  Invalid Login Attempts :{" "}
                  {tok_data.invalid_login_attempts || "0"}
                </div>
              </>
            ) : (
              <></>
            ),
          ]}
          menu_items={dashboard_quick_menu}
        />
        <ErrorWrapper
          error={today_stat_resp}
          onReload={() => {
            this.today_stat.execute();
          }}
        >
          <Skeleton
            active
            className="white-skeleton"
            loading={today_stat_resp.fetching}
          >
            {/* <div style={{
          paddingLeft:8,paddingRight:8
        }}>
        <Alert
          message={<Title level={3} style={{ marginBottom: 0 }} type='secondary'>Good {now < 12 ? "Morning" : "Afternoon"} {user.name}</Title>
          }
          description={<TodayTime />
          }
          type="success"
        />
        </div> */}
            {/* <Text style={{fontSize:20}} type='secondary'>Good Afternoon</Text><br></br> */}

            <Row type="flex">
              <Col {...responsive_card_grid} style={{ padding: 8 }}>
                <KeyboardShortcutWrapper
                  label="P"
                  trigger="Alt+P,Alt+p"
                  onDown={() => {
                    this.props.history.push("/dashboard/pending");
                  }}
                >
                  <IconCard
                    title={today_detail.pending_tasks}
                    subtitle="Pending Tasks"
                    type="warning"
                    style={{
                      height: "100%",
                    }}
                    icon={<ReorderOutlined />}
                    link="/dashboard/pending"
                  />{" "}
                </KeyboardShortcutWrapper>
                {/* <BasicCard
              title="Pending Tasks"
              subtitle={today_detail.pending_tasks}
              link='/dashboard/pending'
              rightIcon={<Avatar size={50} style={{ backgroundColor: COLORS.primary }} icon="info" />}

            /> */}
              </Col>

              <Col {...responsive_card_grid} style={{ padding: 8 }}>
                <KeyboardShortcutWrapper
                  label="G"
                  trigger="Alt+G,Alt+g"
                  onDown={() => {
                    this.props.history.push("/recon/groups");
                  }}
                >
                  <IconCard
                    title={today_detail.assigned_groups}
                    subtitle="Assigned Groups"
                    type="primary"
                    icon={<StorageOutlined />}
                    style={{
                      height: "100%",
                    }}
                    link="/recon/groups"
                  />
                </KeyboardShortcutWrapper>
              </Col>
              {/* <Col {...responsive_card_grid} style={{ padding: 8 }}>
          <IconCard 
            title={today_detail.assigned_process}
            subtitle="Assigned Reconcilers"
            type='success'
            icon={<FlipOutlined />}
            style={{
              height: '100%',
            }}
            link='/a/reconcilers'
            />
          </Col> */}
              <Col {...responsive_card_grid} style={{ padding: 8 }}>
                <KeyboardShortcutWrapper
                  label="R"
                  trigger="Alt+R,Alt+r"
                  onDown={() => {
                    this.props.history.push("/reports/inbox");
                  }}
                >
                  <IconCard
                    title={today_detail.unseen_reports}
                    subtitle="Unseen Reports"
                    type="danger"
                    icon={<AssessmentOutlined />}
                    style={{
                      height: "100%",
                    }}
                    link="/reports/inbox"
                  />
                </KeyboardShortcutWrapper>
                {/* <BasicCard
              title="Unseen Reports"
              subtitle={today_detail.unseen_reports}
              link='/reports/inbox'
              rightIcon={<Avatar size={50} style={{  backgroundColor: COLORS.primary  }} icon="mail" />}

            /> */}
              </Col>
            </Row>
            <Row type="flex">
              <Col span={24} style={{ padding: 8 }}>
                <div
                  className="default-card"
                  style={{
                    margin: 0,
                    padding: 20,
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                    }}
                  >
                    <span
                      className="sub-heading-1"
                      style={{
                        color: COLORS.secondary,
                      }}
                    >
                      Pending Task
                    </span>

                    <Link
                      to={`/dashboard/pending`}
                      className="sub-heading-2"
                      style={{
                        color: COLORS.primary,
                      }}
                    >
                      VIEW ALL
                    </Link>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingTop: 20,
                    }}
                  >
                    <Table
                      style={{ width: "100%" }}
                      // showHeader={false}
                      loading={list_pending_tasks_resp.fetching}
                      className="small-table no-separator-table no-border-table "
                      rowClassName={() => "hand-cursor"}
                      onRow={(record, index) => {
                        return {
                          onClick: () => {
                            this.props.history.push({
                              pathname: `/activity/${record.row_id}`,
                              state: {
                                clicked_notif_id: record.id,
                              },
                            });
                          },
                        };
                      }}
                      columns={[
                        {
                          title: "TASKS",
                          dataIndex: "remark",
                          key: "name",
                        },
                        {
                          title: "DATE",
                          dataIndex: "follow_up_date",
                          key: "date",
                          width: 120,
                        },
                      ]}
                      dataSource={pending_tasks}
                      pagination={false}
                      size="small"
                    />
                  </div>
                </div>
              </Col>
              <Col {...responsive_card_favourite} style={{ padding: 8 }}>
                <div
                  className="default-card"
                  style={{
                    margin: 0,
                    padding: 20,
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                    }}
                  >
                    <span
                      className="sub-heading-1"
                      style={{
                        color: COLORS.secondary,
                      }}
                    >
                      Transaction Quick Links
                    </span>

                    {/* <Link to={`/recon/reconcilers/${this.group_id}/pending`} className='sub-heading-2' style={{
                                        color: COLORS.warning_primary
                                    }}>VIEW ALL</Link> */}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingTop: 20,
                    }}
                  >
                    <Table
                      style={{ width: "100%" }}
                      showHeader={false}
                      loading={list_favourite_datatype_resp.fetching}
                      className="small-table no-separator-table no-border-table "
                      rowClassName={() => "hand-cursor"}
                      onRow={(record, index) => {
                        return {
                          onClick: () => {
                            this.props.history.push(
                              `/activity/data-type/${record.id}/transactions`
                            );
                          },
                        };
                      }}
                      columns={[
                        {
                          title: "NAME",
                          dataIndex: "name",
                          key: "name",
                        },
                      ]}
                      dataSource={favourite_datatypes}
                      pagination={false}
                      size="small"
                    />
                  </div>
                </div>
              </Col>
              <Col {...responsive_card_favourite} style={{ padding: 8 }}>
                <div
                  className="default-card"
                  style={{
                    margin: 0,
                    padding: 20,
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                    }}
                  >
                    <span
                      className="sub-heading-1"
                      style={{
                        color: COLORS.secondary,
                      }}
                    >
                      Group Quick Links
                    </span>

                    {/* <Link to={`/recon/reconcilers/${this.group_id}/pending`} className='sub-heading-2' style={{
                                        color: COLORS.warning_primary
                                    }}>VIEW ALL</Link> */}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingTop: 20,
                    }}
                  >
                    <Table
                      style={{ width: "100%" }}
                      showHeader={false}
                      loading={list_favourite_groups_resp.fetching}
                      className="small-table no-separator-table no-border-table "
                      rowClassName={() => "hand-cursor"}
                      onRow={(record, index) => {
                        return {
                          onClick: () => {
                            this.props.history.push(
                              `/recon/groups/${record.id}/sources`
                            );
                          },
                        };
                      }}
                      columns={[
                        {
                          title: "NAME",
                          dataIndex: "name",
                          key: "name",
                        },
                      ]}
                      dataSource={favourite_reconcilers}
                      pagination={false}
                      size="small"
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <Row type="flex">
              {/* <Col {...responsive_card_today} style={{ padding: 8 }}>
            <BasicCardCenter
              icon={<Avatar size={50} style={{ backgroundColor: '#87d068', marginBottom: 12 }} icon="check" />}
              title={<Title level={4} style={{ margin: 0, textAlign: 'center' }} type='secondary'>Reconciled Today</Title>}
              subtitle={<CountAndAmount count={reconciled_today.total_count}  amount={reconciled_today.total_amount}/>}
              // subtitle={<div>
              //   <Title level={2} style={{ margin: 0, textAlign: 'center', marginTop: 8 }} >{reconciled_today.total_count}</Title> 

              //   </div>}
            />
          </Col>
          <Col {...responsive_card_line} style={{ padding: 8 }}>
            <div className='default-card' style={{
              padding: 8,
              margin:0,
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              justifyContent: 'center'
            }}>
              <Title level={4} underline style={{ margin: 0 }} type='secondary'>Reconciled This Week</Title>
              <ResponsiveContainer height={150} >
                <LineChart
                  data={today_detail.reconciled_this_week||[]}
                  margin={{
                    top: 10, right: 30, left: 0, bottom: 0,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="day" />
                  <YAxis />
                  <Tooltip formatter={(value,name,entry)=>{
                    // console.log("VALUE,",value,name);
                    let payload=entry.payload||{};

                    return <div>
                      <div>Transactions: {payload.total_count}</div>
                      <div>Amount: {formatMoney(payload.total_amount)}</div>
                    </div>
                  }}/>
                  <Line type="monotone" name="Reconciled" dataKey="total_count" stroke="#8884d8" activeDot={{ r: 8 }} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </Col> */}
            </Row>

            <Row type="flex">
              <Col span={24}>
                <Row
                  type="flex"
                  style={{
                    flexWrap: "wrap",
                  }}
                >
                  <Col {...responsive_card_engine} style={{ padding: 8 }}>
                    <EngineStatusCard
                      title="Repository"
                      engine="fetcher"
                      status={engine_status.repository}
                      style={{
                        height: "100%",
                      }}
                    />
                    {/* <EngineStatus
                  title="Repository"
                  status={today_detail.repository}
                /> */}
                  </Col>
                  <Col {...responsive_card_engine} style={{ padding: 8 }}>
                    <EngineStatusCard
                      title="Processing Pipeline"
                      engine="pipeline"
                      status={engine_status.pipeline}
                      style={{
                        height: "100%",
                      }}
                    />
                  </Col>
                  <Col {...responsive_card_engine} style={{ padding: 8 }}>
                    <EngineStatusCard
                      title="Reconciliation"
                      engine="reconciler"
                      status={engine_status.reconciliation}
                      style={{
                        height: "100%",
                      }}
                    />
                  </Col>
                  <Col {...responsive_card_engine} style={{ padding: 8 }}>
                    <EngineStatusCard
                      title="Classification"
                      engine="classification"
                      status={engine_status.classification}
                      style={{
                        height: "100%",
                      }}
                    />
                  </Col>
                  <Col {...responsive_card_engine} style={{ padding: 8 }}>
                    <EngineStatusCard
                      title="Batcher"
                      engine="batcher"
                      status={engine_status.batcher}
                      style={{
                        height: "100%",
                      }}
                    />
                  </Col>
                  <Col {...responsive_card_engine} style={{ padding: 8 }}>
                    <EngineStatusCard
                      title="Cron"
                      engine="cron"
                      status={engine_status.cron}
                      style={{
                        height: "100%",
                      }}
                    />
                  </Col>
                  <Col {...responsive_card_engine} style={{ padding: 8 }}>
                    <EngineStatusCard
                      title="Parser"
                      engine="parser"
                      status={engine_status.parser}
                      style={{
                        height: "100%",
                      }}
                    />
                  </Col>
                  <Col {...responsive_card_engine} style={{ padding: 8 }}>
                    <EngineStatusCard
                      title="Staging"
                      engine="staging"
                      status={engine_status.staging}
                      style={{
                        height: "100%",
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Skeleton>
        </ErrorWrapper>
      </div>
    );
  }

  componentDidMount() {
    this.today_stat.execute();
    this.list_favourite_datatype.execute();
    this.list_favourite_groups.execute();
    this.list_pending_tasks.execute();
  }
}

export default withDomains(TodayPage, "dashboard", "adminAuth");
